<!-- 视频详情 -->
<template>
	<div class="wrap video-box-fixed" :class="{ 'video-box-fixed': showCommentDetail || showVideoArr || showDesc }">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">视频</p>
		</div>

		<div class="video-box" ref="video2">
      <!-- 正常播放器 -->
<!--      <video-player-->
<!--          v-if="info.video_arr.length > 0 && (!videoIsVip || (videoIsVip && isLogin && isVip))"-->
<!--          class="video-player-box"-->
<!--          ref="videoPlayer"-->
<!--          :options="playerOptions"-->
<!--          :playsinline="true"-->
<!--          @play="videoPlay($event)"-->
<!--          @ended="playEnd = true"-->
<!--          @ready="playerReadied">-->
<!--      </video-player>-->

      <!-- 正常播放器 -->
      <div id="player-con"
           class="prism-player"
           v-if="info.video_arr.length > 0 && (!videoIsVip || (videoIsVip && isLogin && isVip))">
      </div>
      <!-- 无法观看提示 -->
      <div class="no-video" v-else>
        <span v-if="info.video_arr.length === 0">正在加载视频资源...</span>
        <span v-else-if="videoIsVip && !isLogin">请登录后观看</span>
        <span v-else-if="videoIsVip && !isVip">您还不是会员，请购买后观看</span>
      </div>
      <!-- 手机号水印 -->
      <div
          ref="position-phone"
          class="position-phone"
          v-if="info.video_arr.length > 0 && (!videoIsVip || (videoIsVip && isLogin && isVip))">{{ userInfo.phone }}
      </div>
    </div>

		<!-- 正常的详情页 -->
		<div class="details-wrap" ref="details-wrap">
			<div class="head">
				<div class="head-top">
					<div class="head-top-between">
						<p class="head-name">{{ info.title }}</p>
					</div>
					<div class="head-row">
            <span class="tag" v-if="videoIsVip">VIP</span>
            <span class="font-1" v-if="videoIsVip">&nbsp·&nbsp</span>
						<span class="font-1">
							<span
								v-if="(info.video_arr || []).length > 0">{{ info.video_arr[videoArrIndex].read_num }}</span>
							播放 ·
							<span @click="showDesc = true">详情></span>
						</span>
					</div>
				</div>
				<div class="head-row-between">
					<div class="head-row-left" v-if="info.video_arr.length > 0">
						<!-- 点赞 -->
						<button type="button" @click="videoTags()">
							<img src="../assets/hand-2active.png" v-if="info.video_arr[videoArrIndex].is_praise === 1">
							<img src="../assets/hand-2.png" v-else>
							{{ info.video_arr[videoArrIndex].praise_num }}
						</button>
						<!-- 收藏 -->
						<button type="button" @click="userCollect()">
							<img src="../assets/star-active.png" v-if="info.video_arr[videoArrIndex].is_collect === 1">
							<img src="../assets/star.png" v-else>
							{{ info.video_arr[videoArrIndex].collect_num }}
						</button>
						<!-- 分享 -->
						<button type="button" @click="showShare = true">
							<img src="../assets/icon-5.png">
							{{ info.video_arr[videoArrIndex].transmit_num }}
						</button>
					</div>
					<div class="head-row-right" v-if="info.video_arr.length > 0">
						<button
                v-if="info.article_id"
                type="button"
                class="border-btn"
                @click="$router.push(`/image-text-details?id=${info.article_id}&item_id=${info.article_item}`)">
              跳转图文
            </button>
            <button type="button"
                    v-if="info.video_arr[videoArrIndex].ppt"
                    @click="toPPT(info.video_arr[videoArrIndex].ppt)">
              查看PPT
            </button>
<!--						<button type="button"-->
<!--                    v-if="info.datum_id"-->
<!--                    @click="$router.push(`/information-details?id=${info.datum_id}&url_id=${info.datum_item}`)">-->
<!--              查看PPT-->
<!--            </button>-->
					</div>
				</div>
			</div>

			<div class="selected-works">
				<p class="selected-works-top" @click="showVideoArr = true">
					<span class="font-2">选集</span>
          <span class="font-2-right">
            共xx期，已更新{{ info.video_arr.length }}期
            <img src="../assets/back-icon.png" class="back-icon">
          </span>
				</p>
				<ul class="selected-works-list">
					<li :class="{ active: videoArrIndex === index }" v-for="(item, index) in info.video_arr"
						:key="index" @click="checkVideo(index)">
						<div class="selected-works-item">
							<span class="selected-works-tag" v-if="item.is_vip === 1">VIP</span>
							<p class="selected-works-row">
								<span class="font-3">{{item.title }}</span>
							</p>
						</div>
					</li>
				</ul>
			</div>

			<div class="comment-module">
				<div class="comment-top">
					<span class="font-2">评论</span>
					<ul class="comment-tab-list">
						<!--						<li class="active">推荐</li>-->
						<li :class="{ active: commentParams.sort_type === 1 }" @click="commentSortTypeCheck(1)">最新</li>
						<li :class="{ active: commentParams.sort_type === 2 }" @click="commentSortTypeCheck(2)">最热</li>
					</ul>
				</div>

				<van-list v-if="info.video_arr.length > 0" :finished-text="commentList.length > 0 ? '没有更多了' : ''"
					v-model="loading" :finished="finished" @load="getVideoCommentList()" style="width: 100%;">
					<ul class="comment-list">
            <li :ref="`comment_${item.id}`" v-for="(item, index) in commentList" :key="index">
              <img :src="item.headimg || require('../assets/avatar.png')" class="avatar">
              <div class="comment-sidebar">
                <div class="comment-row-between2">
                  <p class="font-9">{{ item.name || '游客' }}</p>
                  <div class="comment-btn-box2">
                    <button type="button" @click="videoTagsComment(item)">
                      <img v-if="item.is_like === 1" src="../assets/hand-active.png">
                      <img v-else src="../assets/hand.png">
                      {{ item.like_num || 0 }}
                    </button>
                    <button type="button"
                            class="icon-btn"
                            @click.stop="reportParamsMore = {index, item}; reportParams.report_id = item.id; showReport = true">
                      <img src="../assets/icon-10.png">
                    </button>
                  </div>
                </div>
                <p class="font-5" @click.stop="toComment = item; showCommentSend = true">
                  <span v-if="item.showAll">{{ item.content }}</span>
                  <span v-else>{{ item.contentShort }}</span>
                  <span class="font-color-blue"
                        @click.stop="$set(item, 'showAll', true)"
                        v-if="item.content.length > 50 && !item.showAll"
                  >
                    查看全文
                  </span>
                  <span class="font-color-blue"
                        @click.stop="$set(item, 'showAll', false)"
                        v-if="item.content.length > 50 && item.showAll"
                  >
                    收起
                  </span>
                  <span class="font-color-blue" @click.stop="toComment = item; showCommentSend = true">回复</span>
                </p >
                <p class="font-8">{{ item.create_at }}</p >

                <!-- 回复的上级 -->
                <div class="reply-box" v-if="item.parent && item.parent.id > 0">
                  <div class="reply-row">
                    <span class="reply-name">@{{ item.parent.name || '游客' }}</span>
                    <span class="reply-msg">
                      ：
                      <span v-if="item.parent.showAll">{{ item.parent.content }}</span>
                      <span v-else>{{ item.parent.contentShort }}</span>

                      <span class="font-color-blue"
                            @click.stop="$set(item.parent, 'showAll', true)"
                            v-if="item.parent.content.length > 50 && !item.parent.showAll"
                      >
                        查看全文
                      </span>
                      <span class="font-color-blue"
                            @click.stop="$set(item.parent, 'showAll', false)"
                            v-if="item.parent.content.length > 50 && item.parent.showAll"
                      >
                        收起
                      </span>
                      <span class="font-color-blue" @click.stop="toComment = item.parent; showCommentSend = true">回复</span>
                      <span class="font-color-blue" @click.stop="goParent(item.parent.id)">跳转</span>
                    </span>
                  </div>
                </div>

              </div>
            </li>
<!--						<li v-for="(item, index) in commentList" :key="index">-->
<!--							<img :src="item.headimg || require('../assets/avatar.png')" class="avatar">-->
<!--							<div class="comment-sidebar">-->
<!--								<p class="user-name">{{ item.name }}</p>-->
<!--								<p class="font-4">{{ item.create_at }}</p>-->
<!--								<div class="article-box" @click="toComment = item; showCommentSend = true">-->
<!--									<p class="font-5" v-if="item.showAll">{{ item.content }}</p>-->
<!--									<p class="font-5" v-else>{{ item.contentShort }}</p>-->
<!--									<div class="comment-row-between">-->
<!--										<button type="button" class="all-btn" v-if="item.content.length > 50"-->
<!--											@click.stop="$set(item, 'showAll', !item.showAll)">-->
<!--											{{ item.showAll ? '收起全文' : '…全文' }}-->
<!--										</button>-->
<!--										<span v-else></span>-->
<!--										<img src="../assets/icon.png" class="circle-img" @click.stop="reportParams.report_id = item.id; showReport = true">-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="comment-btn-box">-->
<!--									<button type="button" @click="videoTagsComment(item)">-->
<!--										<img v-if="item.is_like === 1" src="../assets/hand-active.png">-->
<!--										<img v-else src="../assets/hand.png">-->
<!--										{{ item.like_num || 0 }}-->
<!--									</button>-->
<!--									<button type="button" @click="toComment = item; showCommentSend = true">-->
<!--										<img src="../assets/comment.png">-->
<!--									</button>-->
<!--								</div>-->
<!--								<div class="comment-box" v-if="(item.children || []).length > 0">-->
<!--									<p class="comment-box-row" v-for="(item2, index2) in (item.children || [])"-->
<!--										:key="index2" v-if="index2 < 4">-->
<!--										<span class="blue-font">{{ item2.name }}</span>-->
<!--                    <span class="black-font">回复</span>-->
<!--                    <span class="blue-font">@{{ item.name }}</span>-->
<!--                    <span class="black-font">：{{ item2.content }}</span>-->
<!--									</p>-->
<!--									<p class="total-comment-num" @click="toComment = item; showCommentDetail = true"-->
<!--										v-if="item.children.length > 4">-->
<!--										共{{ item.children.length }}条回复-->
<!--										<img src="../assets/back-icon.png">-->
<!--									</p>-->
<!--								</div>-->
<!--							</div>-->
<!--						</li>-->
						<!-- 无数据时显示 -->
						<div class="normal-comment-box" v-if="commentList.length === 0">
							暂无评论
						</div>
					</ul>
				</van-list>
			</div>
		</div>

		<!-- 底部评论固定 -->
		<div class="comment-footer">
			<img :src="userInfo.headimg || require('../assets/avatar.png')" class="avatar-2">
			<div class="comment-footer-sidebar"
           @click="toComment = { id: 0 }; showCommentSend = true; $nextTick(() => $refs['comment-send'].focus())">
				<input type="text" placeholder="发布一条友善的评论" disabled />
			</div>
		</div>

		<!-- 评论窗口 -->
		<van-popup v-model="showCommentSend" round position="bottom">
			<div class="comment-footer-column">
				<div class="comment-footer-between">
					<button type="button" class="cancel-btn" @click="showCommentSend = false">取消</button>
					<button type="button" class="confirm-btn" :class="{active: commentSendParams.content.length > 0 }" @click="commentSend()">完成</button>
				</div>
				<div class="comment-input-wrap">
          <van-field
              ref="comment-send"
              v-model="commentSendParams.content"
              rows="1"
              :autosize=" { maxHeight: 100, minHeight: 20 }"
              type="textarea"
              :placeholder="toComment.id > 0 ? `回复：${toComment.name || '游客'}` : '发布一条友善的评论'"
          />
				</div>
			</div>
		</van-popup>

		<!-- 视频列表的详情页 -->
		<van-popup v-model="showVideoArr" :overlay="false" position="bottom">
			<div class="video-wrap window-height">
				<div class="video-wrap-head">
					<span>选集（{{info.video_arr.length}}）</span>
					<img src="../assets/close-icon2.png" @click="showVideoArr = false">
				</div>
				<ul class="selected-works-list-2">
					<li :class="{ active: videoArrIndex === index }" v-for="(item, index) in info.video_arr"
						:key="index" @click="checkVideo(index)">
						<div class="selected-works-item2">
							<span class="selected-works-tag" v-if="item.is_vip === 1">VIP</span>
							<p class="selected-works-row">
								<span class="font-3-2">{{item.title}}</span>
							</p>
						</div>
					</li>
				</ul>
			</div>
		</van-popup>

		<!-- 视频简介的详情的详情页 -->
		<van-popup v-model="showDesc" :overlay="false" position="bottom">
			<div class="introduce-wrap window-height">
				<div class="introduce-wrap-head">
					<span>简介</span>
					<img src="../assets/close-icon2.png" @click="showDesc = false">
				</div>
				<p class="introduce-msg">
					{{ info.desc  || '暂无简介'}}
				</p>
			</div>
		</van-popup>

		<!-- 举报弹窗 -->
		<van-popup v-model="showReport" round position="bottom">
			<div class="window">
				<div class="window-top">
          <button type="button" class="window-btn del"
                  @click.stop="$router.push(`/report?type=${reportParams.type}&id=${reportParams.report_id}`)">
            <img src="../assets/icon-8.png">举报
          </button>
					<button type="button"
                  class="window-btn del"
                  v-if="reportParams.type === 2 && reportParamsMore.item.user_id === userInfo.id"
                  @click.stop="delComment(reportParams.report_id)">
						<img src="../assets/del-icon2.png">删除
					</button>
				</div>
				<div class="window-btn-box" @click="showReport = false">
					<button type="button">取消</button>
				</div>
			</div>
		</van-popup>

		<!-- 分享弹窗 -->
		<van-popup v-model="showShare" round position="bottom">
			<div class="window">
				<div class="window-top2">
					<button type="button" class="window-btn2" @click="share()">
						<img src="../assets/type-4.png">微信好友
					</button>
					<button type="button" class="window-btn2" @click="share()">
						<img src="../assets/type-3.png">朋友圈
					</button>
				</div>
				<div class="window-btn-box2" @click="showShare = false">
					<button type="button">取消</button>
				</div>
			</div>
		</van-popup>
		<!-- 提示微信分享弹窗 -->
		<van-overlay :show="showWeChatShare" @click="showWeChatShare = false" z-index="99999">
			<img src="../assets/wx-share.png" style="width: 90%; margin-left: 5%" />
		</van-overlay>

    <!-- 显示开通vip -->
    <van-overlay :show="showOpenVip" @click="showOpenVip = false" z-index="99999">
      <div class="open-vip">
        <p>仅支持VIP查看</p>
        <p>开通VIP查看本视频</p>
        <button @click="$router.push('/member')">开通VIP会员</button>
      </div>
    </van-overlay>
	</div>
</template>

<script>
import {
  CollectService,
  UserCenterService, VideoDemandService,
  VideoService
} from "@/common/service";
  import {
    Dialog,
    Toast
  } from "vant";
  import {
    copy,
    isWeChatOpen
  } from "@/common/util";
  const getPlayerOptions = (options = {}) => JSON.parse(JSON.stringify({
    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
    autoplay: false, //如果true,浏览器准备好时开始回放。
    muted: false, // 默认情况下将会消除任何音频。
    loop: false, // 导致视频一结束就重新开始。
    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    language: "zh-CN",
    // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    // sources: [
    //   {
    //     type: "video/mp4",
    //     src: require("../assets/Index/video1.mp4"), //视频url地址
    //   },
    // ],
    // poster: require("../assets/Index/video01.png"), //你的封面地址
    notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
    controlBar: {
      // DurationDisplay
      currentTimeDisplay: true,
      volumePanel: {
        inline: false
      },
      timeDivider: false,
      durationDisplay: true,
      // remainingTimeDisplay: true,
      fullscreenToggle: true, //全屏按钮
    },
    ...options,
  }));
	export default {
		components: {},
		data() {
			return {
        // 是否是微信端打开
        isWeChat: isWeChatOpen(),
        // 显示发送评论窗口
				showCommentSend: false,
        // 显示评论详情
				showCommentDetail: false,
        // 显示选集
				showVideoArr: false,
        // 显示详情
				showDesc: false,
        // 显示举报
				showReport: false,
        // 显示分享
				showShare: false,
        // 显示微信分享
				showWeChatShare: false,
        // 显示开通vip
        showOpenVip: false,
        // 视频播放器参数
        playerOptions: getPlayerOptions(),
        // 视频详情
				info: {
					id: 0,
          // 选集列表
					video_arr: [],
				},
        // 当前选集
				videoArrIndex: 0,
        // 评论列表参数
				commentParams: {
					video_type: 1, // 视频类型（1平台2会员)
					video_id: 0, // 视频id
					url_id: 0, // 平台类型必传
					sort_type: 1, // 排序规则1时间2热点
					page: 1, // 页数
					page_num: 10, // 每页数量
				},
        // 评论列表是否加载
				loading: false,
        // 评论列表加载完成
				finished: false,
        // 评论列表
				commentList: [],
        // 评论参数
				commentSendParams: {
					video_id: 0, // 视频id
					url_id: 0, // 平台类型必传
					content: '',
				},
        // 回复哪条评论
				toComment: {},
        // 是否播放结束
				playEnd: true,
        // 是否重新append
        isAppend: true,
        // 选集id
        videoArrId: 0,
        // 举报参数
        reportParams: {
          type: 2,  // 举报类型（1视频2评论3会员）
          report_id: 0,  // 举报内容的id
        },
        reportParamsMore: {
          index: -1,
          item: {},
        },


        // 视频是否是vip
        videoIsVip: false,
        // 是否登录
        isLogin: false,
        // 用户是否是vip
        isVip: false,
        // 当前登录用户
        userInfo: {},
        // 用户会员等级
        userLevel: {},

        aliPlayer: null,
			};
		},
		mounted() {
      const option = this.$route.query;
      this.videoArrId = parseInt(option.videoArrId || 0);
			const id = parseInt(option.id || 0);
			if (id > 0) {
				this.info.id = id;
				this.commentParams.video_id = id;
				this.commentSendParams.video_id = id;
				this.getVideoDetail();
			}
		},
		methods: {
      toPPT(ppt) {
        location.href = ppt;
      },
      playerReadied() {
        this.isAppend = false;
        setTimeout(() => {
          this.isAppend = true;
          setTimeout(() => {
            // 将滚动文字添加到视频播放组件
            // this.$refs.videoPlayer.player.el_.appendChild(this.$refs["position-msg"]);
            this.$refs.videoPlayer.player.el_.appendChild(this.$refs["position-phone"]);
            // 如果存在选集id则自动播放
            if (this.videoArrId > 0) {
              this.$refs.videoPlayer.player.play();
            }
          }, 10);
        }, 10);
      },
			getUserInfo() {
        const video_arr = this.info.video_arr;
        const {url, cover, ali_vid} = video_arr[this.videoArrIndex];
				UserCenterService.getUserInfo({}, true).then(({
					data
				}) => {
					this.isLogin = true;
					this.userInfo = data.detail;
					this.userLevel = data.user_level || this.userLevel;
					localStorage.setItem('user_info', JSON.stringify(data.detail));
					localStorage.setItem('user_level', JSON.stringify(data.user_level));

          if (this.userLevel && this.userLevel.id > 0) {
            const currentTime = new Date().getTime();
            const endTime = new Date(this.userLevel.end_date.replace(/-/g, '/')).getTime();
            this.isVip = currentTime < endTime;
          }
          if (video_arr.length > 0 && (!this.videoIsVip || this.videoIsVip && this.isLogin && this.isVip)) {
            // 初始化播放器
            setTimeout(() => this.initAliPlayer(url, cover, ali_vid), 100);
          }
				}).catch(() => {
          if (!this.videoIsVip) {
            // 初始化播放器
            setTimeout(() => this.initAliPlayer(url, cover, ali_vid), 100);
          }
        });
			},
			getVideoDetail() {
				return VideoService.getVideoDetail({
					id: this.info.id
				}).then(({
					data
				}) => {
          const video_arr = data.detail.video_arr || [];
          const videoArrIds = video_arr.map(item => item.id);
          if (videoArrIds.indexOf(this.videoArrId) > -1) {
            this.videoArrIndex = videoArrIds.indexOf(this.videoArrId);
          }
          if(video_arr.length > 0) {
            this.playerOptions = getPlayerOptions({
              sources: video_arr[this.videoArrIndex].url,
              poster: video_arr[this.videoArrIndex].cover,
            });
            this.videoIsVip = video_arr[this.videoArrIndex].is_vip === 1;
          }
					this.info = data.detail;
          this.getUserInfo();
					this.initShare();
					this.getVideoCommentList();
				});
			},

      // 初始化阿里云播放器
      initAliPlayer(url, cover, ali_vid) {
        // 自定义组件 - 手机号
        const positionPhone = Aliplayer.Component({
          init: () => {},
          createEl: (el) => el.appendChild(this.$refs["position-phone"]),
        });
        const aliPlayerOption = {
          id: 'player-con',
          format: "m3u8",
          mediaType: "video",
          width: '100%',
          height: `${this.$refs['video2'].clientHeight}px`,
          autoplay: false,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: 'hover',
          useH5Prism: true,
          components: [
            {name:'positionPhone',type: positionPhone},
          ],
          skinLayout: [
            {
              "name": "bigPlayButton",
              "align": "blabs",
              "x": 30,
              "y": 80
            },
            {
              "name": "H5Loading",
              "align": "cc"
            },
            {
              "name": "errorDisplay",
              "align": "tlabs",
              "x": 0,
              "y": 0
            },
            {
              "name": "infoDisplay"
            },
            {
              "name": "tooltip",
              "align": "blabs",
              "x": 0,
              "y": 56
            },
            {
              "name": "thumbnail"
            },
            {
              "name": "controlBar",
              "align": "blabs",
              "x": 0,
              "y": 0,
              "children": [
                {
                  "name": "progress",
                  "align": "blabs",
                  "x": 0,
                  "y": 44
                },
                {
                  "name": "playButton",
                  "align": "tl",
                  "x": 15,
                  "y": 12
                },
                {
                  "name": "timeDisplay",
                  "align": "tl",
                  "x": 10,
                  "y": 7
                },
                {
                  "name": "fullScreenButton",
                  "align": "tr",
                  "x": 10,
                  "y": 12
                },
                {
                  "name": "setting",
                  "align": "tr",
                  "x": 15,
                  "y": 12
                },
                {
                  "name": "volume",
                  "align": "tr",
                  "x": 5,
                  "y": 10
                }
              ]
            }
          ]
        };
        const aliplayerCreatedFn = (player) => {
          // 360浏览器层级问题
          player.tag.setAttribute('controls360', 'no');
          player.tag.setAttribute('controlsList', 'nodownload noremote footbar');

          player.tag.currentTime = 1;
          setTimeout(() => {
            player.play()
            setTimeout(() => player.pause(), 50);
          }, 50);

          player.play();
          player.pause();
          // console.log();
          // 如果存在选集id则自动播放
          if (this.videoArrId > 0) {
            player.play();
          }
          player.on('play', () => this.videoPlay());
          player.on('ended', () => this.playEnd = true);
        };
        VideoDemandService.getVideoCredentials().then(({data}) => {
          const encryptOption = {
            isDrm: true,
            //必选参数。可以通过点播控制台（路径：媒资库>音/视频）查询。示例：1e067a2831b641db90d570b6480f****。
            vid: ali_vid,
            //必选参数。可通过RAM访问控制控制台的AccessKey管理页面创建AccessKey，或者查看已有AccessKey Id的AccessKey Secret。
            accessKeyId: data.Credentials.AccessKeyId,
            //必选参数。视频播放的临时凭证。凭证需要提前生成。生成方式请参考创建角色并进行STS临时授权。
            securityToken: data.Credentials.SecurityToken,
            //必选参数。可通过RAM访问控制控制台的AccessKey管理页面创建AccessKey，或者查看已有AccessKey Id的AccessKey Secret。
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 必选参数。媒体资源所在的区域。如cn-shanghai、eu-central-1, ap-southeast-1等。
            region: data.Credentials.region,
            // 仅苹果设备播放需要。用于请求苹果证书，可根据DRM加密的实现到视频点播或视频直播控制台获取。
            certId: '3decf53e70144a97a33a3c844d0fe6a2',
          };
          this.aliPlayer = new Aliplayer({...aliPlayerOption, ...encryptOption}, aliplayerCreatedFn);
        });
      },

			// 点赞
			videoTags() {
				const video = this.info.video_arr[this.videoArrIndex];
				return VideoService.videoTags({
						type: 2,
						like_id: video.id
					})
					.then(({
						msg,
						data
					}) => {
						Toast(msg);
						this.$set(video, 'is_praise', data.tags);
						this.$set(video, 'praise_num', video.praise_num + (video.is_praise === 1 ? 1 : -1));
					});
			},

			// 点赞评论
			videoTagsComment(item) {
				const video = this.info.video_arr[this.videoArrIndex];
				return VideoService.videoTags({
						type: 1,
						like_id: item.id
					})
					.then(({
						msg,
						data
					}) => {
						Toast(msg);
						this.$set(item, 'is_like', data.tags);
						this.$set(item, 'like_num', item.like_num + (item.is_like === 1 ? 1 : -1));
					});
			},
      // 删除评论
      delComment(id) {
        return Dialog.confirm({
          message: '确定删除评论？',
        }).then(() => {
          VideoService.delComment({
            id,
          }).then(({msg}) => {
            Toast(msg);
            this.showReport = false;
            this.commentParams.page = 1;
            this.finished = false;
            this.getVideoCommentList();
          });
        });
      },

			// 收藏
			userCollect() {
				const video = this.info.video_arr[this.videoArrIndex];
				return CollectService.userCollect({
						coll_type: 1,
						coll_id: video.id
					})
					.then(({
						msg,
						data
					}) => {
						Toast(msg);
						this.$set(video, 'is_collect', data.status);
						this.$set(video, 'collect_num', video.collect_num + (video.is_collect === 1 ? 1 : -1));
					});
			},

			// 评论列表
			getVideoCommentList() {
				const params = this.commentParams;
				params.url_id = this.info.video_arr[this.videoArrIndex].id;
				this.loading = true;
				return VideoService.getVideoCommentList(params).then(({
					data
				}) => {
					const list = data.list.map(item => {
						item.contentShort = item.content.substring(0, 50);
            if (item.parent && item.parent.id > 0) {
              item.parent.contentShort = item.parent.content.substring(0, 50);
            }
						return item;
					});
					this.commentList = this.commentParams.page === 1 ? list : [...this.commentList, ...list];
					if (list.length < params.page_num) {
						this.finished = true;
					} else {
						this.commentParams.page++;
					}
          return list;
				}).finally(() => {
					this.loading = false;
				});
			},

      goParent(id) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: '加载中..',
        });
        const go = () => {
          const parentDom = this.$refs[`comment_${id}`][0];
          if (!parentDom) {
            Toast.clear();
            console.log('未找到');
          }
          const detailsWrapOffsetTop = this.$refs['details-wrap'].offsetTop;
          console.log(parentDom.offsetTop, detailsWrapOffsetTop, parentDom);
          document.documentElement.scrollTop = parentDom.offsetTop - detailsWrapOffsetTop;
          Toast.clear();
        };

        const getComment = () => {
          const ids = this.commentList.map(item => item.id);
          if (ids.includes(id)) {
            if (this.finished) {
              go();
            } else {
              this.getVideoCommentList().then(() => go());
            }
            return;
          }
          this.getVideoCommentList().then(() => {
            getComment();
          });
        };
        getComment();
      },

			// 发送评论
			commentSend() {
				const params = this.commentSendParams;
				if (this.toComment.id > 0) {
					return VideoService.secondCommend({
						id: this.toComment.id,
						content: params.content
					}).then(({
						msg,
						data
					}) => {
						Toast(msg);
						this.showCommentSend = false;
						this.commentSendParams.content = '';
						data.detail.contentShort = data.detail.content.substring(0, 50);
            data.detail.user_id = this.userInfo.id;
            data.detail.parent = this.toComment;
            if (this.commentParams.sort_type === 1) {
              this.commentList.unshift(data.detail);
            } else if (this.finished) {
              this.commentList.push(data.detail);
            }
					});
				} else {
					params.url_id = this.info.video_arr[this.videoArrIndex].id;
					return VideoService.videoComment(params).then(({
						msg,
						data
					}) => {
						Toast(msg);
						this.showCommentSend = false;
						this.commentSendParams.content = '';
						data.detail.contentShort = data.detail.content.substring(0, 50);
            data.detail.user_id = this.userInfo.id;
						if (this.commentParams.sort_type === 1) {
							this.commentList.unshift(data.detail);
						} else if (this.finished) {
							this.commentList.push(data.detail);
						}
					});
				}
			},

			// 播放
			videoPlay() {
				if (this.playEnd) {
					this.playEnd = false;
					const params = {
						video_type: 1, // 视频类型（1平台2会员)
						video_id: this.info.id, // 视频id
						url_id: this.info.video_arr[this.videoArrIndex].id, // 平台类型必传
					}
					VideoService.videoPlay(params).then(() => {
						this.info.video_arr[this.videoArrIndex].read_num += 1;
					});
				}
			},

			checkVideo(index) {
        const videoIsVip = this.info.video_arr[index].is_vip === 1;
        if (videoIsVip) {
          if (!this.isLogin) {
            return Dialog.confirm({
              message: 'VIP视频请登录后观看',
              confirmButtonText: '去登录'
            }).then(() => {
              this.$router.push('/login');
            });
          }
          if (!this.isVip) {
            return this.showOpenVip = true;
            // return Dialog.confirm({
            //   message: '您还不是会员，请购买后观看',
            //   confirmButtonText: '去购买'
            // }).then(() => {
            //   this.$router.push('/member');
            // });
          }
        }
        if (this.videoArrIndex !== index) {
          const id = this.info.id;
          const videoArrId = this.info.video_arr[index].id;
          const path = `/video-details?id=${id}&videoArrId=${videoArrId}`;
          // location.href=path;
          //   this.$router.push(path);
          if (this.videoArrId > 0) {
            this.$router.replace(path);
          } else {
            this.$router.push(path);
          }
        }
        // return;
				// this.playEnd = true;
				// this.videoArrIndex = index;
        // this.playerOptions = getPlayerOptions({
        //   sources: this.info.video_arr[index].url,
        //   poster: this.info.video_arr[index].cover,
        // });
        // this.videoIsVip = this.info.video_arr[this.videoArrIndex].is_vip === 1;
				// this.commentParams.page = 1;
				// this.finished = false;
				// this.getVideoCommentList();
			},

			// 评论列表排序方式
			commentSortTypeCheck(sortType) {
				if (this.loading) {
					return;
				}
				this.commentParams.sort_type = sortType;
				this.commentParams.page = 1;
				this.finished = false;
				this.getVideoCommentList();
			},

			initShare() {
				const info = this.info;
				const video = this.info.video_arr[this.videoArrIndex];
				let link = location.href;
				if (link.indexOf('videoArrId=') < 0) {
					link += '&videoArrId=' + video.id;
				}
				const shareOption = {
					link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
					title: video.title, // 分享标题
					imgUrl: video.cover.indexOf('http') > -1 ? video.cover : `http:${video.cover}`, // 分享图标
					desc: info.desc || '', // 分享描述
				};
				// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
				this.$wx.updateAppMessageShareData({
					...shareOption,
					// 设置成功
					success: () => {}
				});
				// 自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
				this.$wx.updateTimelineShareData({
					...shareOption,
					// 设置成功
					success: () => {}
				});
			},
			share() {
				this.showShare = false;
        if (this.isWeChat) {
          this.showWeChatShare = true;
          this.initShare();
        } else {
          const video = this.info.video_arr[this.videoArrIndex];
          let link = location.href;
          if (link.indexOf('videoArrId=') < 0) {
            link += '&videoArrId=' + video.id;
          }
          copy(link);
          Toast('已复制链接到粘贴板');
        }
        // return;
				const params = {
					video_type: 1, // 视频类型（1平台2会员)
					video_id: this.info.id, // 视频id
					url_id: this.info.video_arr[this.videoArrIndex].id, // 平台类型必传
				}
				VideoService.videoTransmit(params).then(() => {
					this.info.video_arr[this.videoArrIndex].transmit_num += 1;
				});
			},

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 44px 0 83px;
		box-sizing: border-box;
	}

	.video-box-fixed {
		padding: 254px 0 83px;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.video-box {
		width: 100%;
		height: 210px;
		border: 1px solid #ccc;
		box-sizing: border-box;
		position: relative;
	}

	.position-msg {
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
  .position-phone{
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 66.666666%;
    color: #FFFFFF;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 2.5vw;
    height: 5vw;
    padding: 0 2vw;
    opacity: 0.8;
    font-size: 2.5vw;
  }

	.video-box-fixed .video-box {
		position: fixed;
		top: 44px;
		z-index: 500;
	}

  .video-box .video-player-box,
  .video-box .video-player-box >>> .video-js,
  .video-box .video-player-box >>> video{
		width: 100%;
		height: 210px !important;
		background-color: #000000;
    padding: 0;
	}
  .video-box .video-player-box >>> .vjs-fullscreen video{
    width: 100%;
    height: auto !important;
    top: 50%;
    transform: translateY(-50%);
  }
  .video-box >>> .prism-big-play-btn{
    top: calc(50% - 32px) !important;
    left: calc(50% - 32px) !important;
  }
  .video-player-box >>> .vjs-big-play-button {
    top: calc(50% - 22.5px);
    left: calc(50% - 45px);
  }

	.head {
		width: 100%;
		display: flex;
		flex-direction: column;
		border-bottom: 1px solid #F3F3F3;
		padding: 10px 0 15px;
		box-sizing: border-box;
	}

	.head-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.head-name {
		width: 100%;
		color: #222222;
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 3px;
	}

	.head-row {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.tag {
		width: fit-content;
		height: 14px;
		line-height: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 6px;
		color: #78581D;
		font-size: 10px;
		background-color: #F3D170;
		border-radius: 10px;
		margin-right: 2px;
	}

	.font-1 {
		color: #7F7F7F;
		font-size: 12px;
	}

	.head-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
		padding-right: 15px;
		box-sizing: border-box;
	}

	.head-row-left {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.head-row-left>button {
		/*flex: 1;*/
    width: 60px;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #7F7F7F;
		font-size: 10px;
	}

	.head-row-left>button>img {
		height: 21px;
		margin-bottom: 8px;
	}

	.head-row-right {
		display: flex;
		align-items: center;
		margin-left: 20px;
	}

	.head-row-right>button {
		background-color: #2A63F3;
		border-radius: 50px;
		height: 22px;
		line-height: 22px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 12px;
		padding: 0 7px;
		width: fit-content;
		margin-right: 10px;
		box-sizing: border-box;
	}

	.head-row-right>button:last-child {
		margin-right: 0;
	}

	.head-row-right>button.border-btn {
		color: #2A63F3;
		background-color: #F4F8FF;
		border: 1px solid #6F8EF8;
	}

	.selected-works {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 11px 0 10px;
	}

	.selected-works-top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.font-2 {
		color: #222222;
		font-size: 16px;
		font-weight: 500;
	}
  .font-2-right{
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #7F7D87;
  }

  .font-2-right .back-icon{
    margin-left: 4px;
  }

	.back-icon {
		width: 6px;
	}

	.selected-works-list {
		width: 100%;
		white-space: nowrap;
		overflow-x: auto;
		padding-left: 15px;
		box-sizing: border-box;
	}

	.selected-works-list>li {
		display: inline-block;
		width: 120px;
		margin-right: 10px;
		background-color: #F4F4F4;
		border-radius: 6px;

    vertical-align: middle;
	}

	.selected-works-list>li:last-child {
		margin-right: 15px;
	}

	.selected-works-list>li.active {
		border: 1px solid #6F8EF8;
		background-color: #F4F8FF;
	}

	.selected-works-item {
		width: 100%;
		/*height: 46px;*/
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		padding: 12px 5px 12px 11px;
		box-sizing: border-box;

	}

	.selected-works-tag {
		position: absolute;
		right: 0;
		top: 0;
		width: 24px;
		line-height: 12px;
		height: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 0 5px 0 5px;
		background-color: #F3D170;
		color: #78581D;
		font-size: 10px;
	}

	.selected-works-row {
		width: 100%;
    height: 33px;
		display: flex;
		flex-direction: column;
    justify-content: center;
	}

	.font-3 {
		width: 100%;
		color: #222222;
		font-size: 12px;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
	}

	.font-3:last-child {
		margin-bottom: 0;
	}

	.comment-module {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.comment-top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 15px 0;
		box-sizing: border-box;
	}

	.comment-tab-list {
		display: flex;
		align-items: center;
	}

	.comment-tab-list>li {
		color: #999999;
		font-size: 12px;
		padding: 0 7px;
		position: relative;
	}

	.comment-tab-list>li::after {
		content: "";
		width: 1px;
		height: 10px;
		background-color: #D8D8D8;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(0, -50%);
	}

	.comment-tab-list>li:last-child::after {
		background-color: initial;
	}

	.comment-tab-list>li.active {
		color: #222222;
	}

	.comment-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.comment-list>li {
		width: 100%;
		display: flex;
		align-items: flex-start;
		padding: 10px 15px;
		border-bottom: 1px solid #F3F3F3;
		box-sizing: border-box;
	}

	.avatar {
		width: 38px;
		height: 38px;
		border-radius: 50%;
		object-fit: cover;
		margin-right: 12px;
	}

	.comment-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.user-name {
		width: 100%;
		color: #2A63F3;
		font-size: 14px;
		margin-bottom: 3px;
	}

	.font-4 {
		width: 100%;
		color: #999999;
		font-size: 10px;
		margin-bottom: 5px;
	}

	.article-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 4px;
	}

	.font-5 {
		width: 100%;
		color: #222222;
		font-size: 14px;
    white-space:normal;
    word-break:break-all;
	}

	.comment-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.comment-row-between.margin {
		margin-top: 9px;
		margin-bottom: 0px;
	}

	.all-btn {
		color: #2A63F3;
		font-size: 13px;
	}

	.circle-img {
		width: 3px;
	}

	.comment-btn-box,
	.comment-btn-box2 {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.comment-btn-box2 {
		width: initial !important;
		flex: 1;
	}

	.comment-btn-box>button,
	.comment-btn-box2>button {
		display: flex;
		align-items: center;
		margin-right: 14px;
		color: #999999;
		font-size: 12px;
	}

	.comment-btn-box>button>img,
	.comment-btn-box2>button>img {
		width: 12px;
		margin-right: 4px;
	}

	.comment-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 8px 10px 10px;
		box-sizing: border-box;
		border-radius: 10px;
		background-color: #F3F3F3;
	}

	.comment-box-row {
		width: 100%;
		margin-bottom: 4px;
	}

	.comment-box-row:last-child {
		margin-bottom: 0;
	}

  .comment-box-row>span{
    word-break: break-all;
  }

	.blue-font {
		color: #2A63F3;
		font-size: 13px;
	}

	.black-font {
		color: #333333;
		font-size: 13px;
	}

	.total-comment-num {
		width: 100%;
		color: #777777;
		font-size: 10px;
		display: flex;
		align-items: center;
	}

	.total-comment-num>img {
		width: 4px;
		margin-left: 2px;
	}

	.normal-comment-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		padding: 66px 0;
		font-size: 14px;
		color: #7F7F7F;
	}

	.comment-footer {
		width: 100%;
		height: 83px;
		display: flex;
		align-items: center;
		padding: 12px 15px;
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
	}

	.avatar-2 {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin-right: 10px;
		object-fit: cover;
	}

	.comment-footer-sidebar {
		flex: 1;
		height: 38px;
		line-height: 38px;
		border-radius: 40px;
		background-color: #F3F3F3;
		padding: 0 16px;
		box-sizing: border-box;
	}

	.comment-input {
		width: 100%;
		font-size: 14px;
	}

	.comment-input::placeholder {
		color: #999992;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		/*position: fixed;*/
		/*bottom: 0;*/
		/*left: 0;*/
		z-index: 99999999;
		background-color: #FFFFFF;
		border-radius: 16px 16px 0 0;
	}

	.mask-layer {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
	}

	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 35px 25px;
		box-sizing: border-box;
	}

	.window-top2 {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 25px 25px 23px;
		box-sizing: border-box;
	}

	.window-btn {
		width: 100%;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 16px;
		margin-bottom: 30px;
	}

	.window-btn:last-child {
		margin-bottom: 0;
	}

	.window-btn.del {
		color: #FF1010;
	}

	.window-btn>img {
		width: 24px;
		margin-right: 16px;
	}

	.window-btn2 {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 13px;
	}

	.window-btn2>img {
		height: 38px;
		margin-bottom: 5px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 15px 38px;
		box-sizing: border-box;
	}

	.window-btn-box>button {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #F3F3F3;
		border-radius: 100px;
		color: #222222;
		font-size: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.window-btn-box2 {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 14px 0 47px;
		box-sizing: border-box;
		border-top: 1px solid #F2F2F2;
	}

	.window-btn-box2>button {
		color: #999999;
		font-size: 16px;
	}

	.details-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
	}


	/* 评论 */
	.comment-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.comment-wrap-head {
		width: 100%;
		/*height: 100%;*/
		display: flex;
		flex-direction: column;
		border-bottom: 10px solid #F7F7F7;
		box-sizing: border-box;
		padding-top: 49px;
	}

	.comment-wrap-head-top {
		width: 100%;
		height: 49px;
		border-bottom: 1px solid #F2F2F2;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 16px;
		font-weight: 500;
		padding: 0 15px;
		box-sizing: border-box;
		position: fixed;
		background-color: #FFFFFF;
	}

	.comment-wrap-head-top>img {
		width: 16px;
		margin-right: 6px;
	}

	.comment-wrap-bottom {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.all-comment-row {
		width: 100%;
		padding: 10px 15px 0;
		box-sizing: border-box;
		color: #999999;
		font-size: 12px;
	}

	.all-comment-row>span {
		color: #222222;
		font-size: 16px;
		font-weight: 500;
		margin-right: 6px;
	}

	/* 简介 */
	.introduce-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 17px;
		box-sizing: border-box;
	}

	.introduce-wrap-head {
		width: 100%;
		height: 49px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.introduce-wrap-head>span {
		color: #222222;
		font-size: 16px;
		font-weight: 500;
	}

	.introduce-wrap-head>img {
		width: 14px;
	}

	.introduce-msg {
		width: 100%;
		font-size: 12px;
		color: #222222;
	}

	/* 视频列表 */
	.video-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 15px;
		box-sizing: border-box;
	}

	.video-wrap-head {
		width: 100%;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.video-wrap-head>span {
		color: #222222;
		font-size: 16px;
		font-weight: 500;
	}

	.video-wrap-head>img {
		width: 14px;
	}

	/* 视频列表 */
	.selected-works-list-2 {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.selected-works-list-2>li {
		width: calc(50% - 7.5px);
		background-color: #F4F4F4;
		border-radius: 6px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.selected-works-list-2>li.active {
		border: 1px solid #6F8EF8;
		background-color: #F4F8FF;
	}

	.selected-works-item2 {
		width: 100%;
		min-height: 50px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		padding: 0 7px;
		box-sizing: border-box;
	}

	.selected-works-tag {
		position: absolute;
		right: 0;
		top: 0;
		width: 24px;
		line-height: 12px;
		height: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 0 5px 0 5px;
		background-color: #F3D170;
		color: #78581D;
		font-size: 10px;
	}

	.selected-works-row {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.font-3-2 {
		width: 100%;
		color: #222222;
		font-size: 12px;
		padding: 7px 0;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
	}

	.head-name {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	/* 新增 */
	.head-top-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.report {
		background-color: #2A63F3;
		border-radius: 50px;
		height: 25px;
		line-height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 12px;
		font-weight: 500;
		width: 60px;
		box-sizing: border-box;
	}

	.head-name {
		width: initial !important;
		flex: 1;
	}

	.window-height {
		height: calc(var(--viewport-height) - 254px);
		/*min-height: 300px;*/
		overflow: auto;
		position: relative;
	}

	/* 新增 */
	.comment-footer-column {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px 20px;
		box-sizing: border-box;
	}

	.comment-footer-between {
		width: 100%;
		height: 52px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.comment-footer-between button.cancel-btn {
		color: #333333;
		font-size: 15px;
	}

  .comment-footer-between button.confirm-btn {
		width: 62px;
		height: 28px;
		line-height: 28px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 15px;
		background-color: #B0B9CD;
	}

  .comment-footer-between button.confirm-btn.active {
    background-color: #2A63F3;
  }

	.comment-input-wrap {
		width: 100%;
		line-height: 38px;
		border-radius: 19px;
		background-color: #F3F3F3;
		padding: 0 16px;
		box-sizing: border-box;
	}
  .comment-input-wrap .van-field {
    background-color: #F3F3F3;
    padding: 8px 0;
    font-size: 15px;
  }

	.comment-input-wrap input {
		width: 100%;
	}

  /* 新增css */
  .reply-box {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .reply-row {
    width: 100%;
    margin-bottom: 3px;
  }

  .reply-row:last-child {
    margin-bottom: 0;
  }

  .reply-msg {
    color: #333333;
    font-size: 13px
  }

  .reply-name {
    color: #2A63F3;
    font-size: 13px
  }
  .font-color-blue {
    display: inline-block;
    width: max-content;
    color: #2A63F3;
    margin: 0 4px;
  }

  .comment-row-between2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .font-8 {
    width: 100%;
    color: #999999;
    font-size: 10px;
    margin: 5px 0;
  }

  .font-9 {
    width: 100%;
    color: #333;
    font-weight: 500;
    font-size: 15px;
    margin-bottom: 3px;
  }

  .icon-btn {
    height: 17px;
    margin-right: 0 !important;
  }

  .icon-btn>img {
    width: initial !important;
    height: 3px;
  }
  .no-video{
    background: rgba(0, 0, 0, .9);
    color: #FFFFFF;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
  .open-vip {
    width: 275px;
    height: 170px;
    background: #FFFFFF;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 273px auto 0;
  }
  .open-vip p{
    font-size: 16px;
    font-weight: 500;
    color: #222222;
    line-height: 35px;
  }
  .open-vip button{
    width: 215px;
    height: 40px;
    background: #EBD793;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 500;
    color: #553D0E;
    margin-top: 10px;
  }
</style>
